export class ContractNumber {
  number: string
}

const buildContractNumber = (number: string = ''): ContractNumber => {
  return {
    number: number
  }
}

export {
  buildContractNumber
}



// WEBPACK FOOTER //
// ./src/types/contract-number.js